// extracted by mini-css-extract-plugin
export default {"normalText":"styles_normalText__lHnFC","container":"styles_container__NSgrp","ScrollbarsCustom_Content":"styles_ScrollbarsCustom_Content__Fmn+H"};